import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=fac5d2dc&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=fac5d2dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac5d2dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fac5d2dc')) {
      api.createRecord('fac5d2dc', component.options)
    } else {
      api.reload('fac5d2dc', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=fac5d2dc&scoped=true&", function () {
      api.rerender('fac5d2dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zFqSiKck8QSp/JS/comp/CookieBox.vue"
export default component.exports